* {
  box-sizing: border-box;
}

.progress-container {
  height: 15px;
  background-color: var(--chart-050-hover);
  position: relative;
  width: 100%;

  .progress {
    transition: width 0.5s cubic-bezier(0.37, 0.11, 0.83, 0.67);
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
  }
}

:host(:not([animations])) {
  .progress-container {
    .progress {
      transition: none;
    }
  }
}
